import { render, staticRenderFns } from "./PagesModal.vue?vue&type=template&id=39bdf510&"
import script from "./PagesModal.vue?vue&type=script&lang=js&"
export * from "./PagesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports